<template>
  <div>
    <template>
      <div class="row custom-row">
        <div class="row">
          <div class="col-sm-12 col-xs-12 col-md-12">
            <hr class="mr-bt-4" />
            <div class="row ipad-row">
              <div class="col-md-2 col-sm-3 col-xs-12 portrait-xs-12-width">
                <span>Panel Selector:</span>
              </div>
              <div
                class="col-md-2 col-sm-2 col-xs-6 width-auto"
                v-for="panel in panelInfo"
                :key="panel.id"
              >
                <div class="form-check">
                  <base-radio
                    :id="panel.id"
                    :optionValue="panel.id"
                    v-model="panel_id"
                    @change="selectPanel()"
                    :label="panel.id"
                  >
                    <span>{{ panel.name }}</span>
                  </base-radio>
                </div>
              </div>
            </div>
            <hr class="mt-0" />
          </div>
        </div>
      </div>
      <div class="box-wrapper">
        <div class="row custom-row mr-tp-10" v-if="panel_id !== 1">
          <span>Select a RAMS feature for each panel below</span>
        </div>
        <div class="col-xs-12 center" v-if="panel_id == 1 && panelInfo">
          <img
            class="default-img"
            src="/static/images/marketplace/default-dashboard.png"
            alt="default-img"
          />
        </div>
        <div class="row custom-row" v-if="panel_id !== 1">
          <div class="col-md-6 col-sm-12 col-xs-12">
            <div
              class="row mt-20"
              v-for="(panels, index) in panelsDisplay.card_widget_info"
              :key="index"
            >
              <div
                class="col-md-2 col-sm-12 col-xs-12 p-0"
                :class="{ 'mr-tp-4': panels.fixed_panel_widget_id == null }"
              >
                Panel {{ panels.card_number }}:
              </div>
              <div class="col-md-8 col-sm-12 col-xs-12 p-0">
                <span class="custom-font ml-20" v-if="panels.fixed_panel_widget_id != null"
                  >{{ panels.list[0].drop_down_name }}<span class="fw-300"> (fixed)</span></span
                >
                <multiselect
                  v-if="
                    selectedPanel[index].panel_widget_id != 1 &&
                    !panelCardIdList.includes(selectedPanel[index].panel_card_id)
                  "
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  class="multiselect-single-dropdown"
                  :class="!selectedPanel[index].panel_widget_id ? 'un-selected' : ''"
                  :searchable="false"
                  :options="panels.list.map((dropdownObj) => dropdownObj.id)"
                  :custom-label="
                    (option) => panels.list.find((x) => x.id === option).drop_down_name
                  "
                  v-model="selectedPanel[index].panel_widget_id"
                  placeholder="Select"
                >
                  <span slot="noResult">No matching data</span>
                </multiselect>
                <multiselect
                  v-if="
                    selectedPanel[index].panel_widget_id != 1 &&
                    panelCardIdList.includes(selectedPanel[index].panel_card_id)
                  "
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  class="multiselect-single-dropdown"
                  :class="!selectedPanel[index].panel_widget_id ? 'un-selected' : ''"
                  :searchable="false"
                  open-direction="bottom"
                  :options="panels.list.map((dropdownObj) => dropdownObj.id)"
                  :custom-label="
                    (option) => panels.list.find((x) => x.id === option).drop_down_name
                  "
                  v-model="selectedPanel[index].panel_widget_id"
                  placeholder="Select"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-5 col-sm-12 col-xs-12 panel-box">
            <div class="box1">
              <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 panel-1">1</div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                  <div class="row panel-other">2</div>
                  <div class="row panel-other">3</div>
                </div>
              </div>
              <div class="row">
                <div
                  class="panel-other"
                  :class="{
                    'col-lg-12 col-md-12 col-sm-12 col-xs-12': panel_id == 2,
                    'col-lg-6 col-md-6 col-sm-6 col-xs-6': panel_id == 3,
                    'col-lg-4 col-md-4 col-sm-4 col-xs-4': panel_id == 4
                  }"
                >
                  4
                </div>
                <div
                  class="panel-other"
                  v-if="panel_id != 2"
                  :class="{
                    'col-lg-6 col-md-6 col-sm-6 col-xs-6': panel_id == 3,
                    'col-lg-4 col-md-4 col-sm-4 col-xs-4': panel_id == 4
                  }"
                >
                  5
                </div>
                <div
                  class="panel-other"
                  v-if="panel_id == 4"
                  :class="{ 'col-lg-4 col-md-4 col-sm-4 col-xs-4': panel_id == 4 }"
                >
                  6
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 footer">
          <div class="col-md-2 col-sm-3 col-xs-5 col-md-offset-7 col-sm-offset-5">
            <button
              type="button"
              class="btn btn-block emergo-white-button"
              @click="cancelPreferences"
            >
              Cancel
            </button>
          </div>
          <div class="col-md-3 col-xs-7 col-sm-4">
            <button
              type="button"
              @click="savePreferences"
              class="btn btn-block emergo-green-button"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </template>
    <error-modal :errorMessage="errorMessage"></error-modal>
    <success-modal @closeParent="closePopup(true)" :successMessage="successMessage"></success-modal>
    <confirm-modal @closePopup="closePopup" :confirmMessage="confirmMessage"></confirm-modal>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import $ from 'jquery';
import { sortBy, cloneDeep } from 'lodash';
import getSasToken from '../../apis/sasToken';
import EventBus from '../../utils/event-bus';
import {
  getPanelInfo,
  getCardTypeInfo,
  getPanelCardWidgetInfo,
  getWidgetListForAccount,
  postUserPreferences,
  isDefaultDashboard,
  getUserDashboardPreference,
  putUserPreferences,
  setDefaultPreference
} from '../../apis/dashboardCustomization';
import Loader from '../UIComponents/Loader.vue';
import ErrorModal from '../Common/ErrorModal.vue';
import SuccessModal from '../Common/SuccessModal.vue';
import ConfirmModal from '../Common/ConfirmModal.vue';
import BaseRadio from '../Common/BaseRadio.vue';

export default {
  components: {
    Loader,
    ErrorModal,
    SuccessModal,
    ConfirmModal,
    BaseRadio
  },
  props: ['roleId'],

  data() {
    return {
      panelCardIdList: [2, 3, 6, 7, 11, 12, 13],
      panelInfo: [],
      cardTypeInfo: [],
      panelCardWidgetInfo: [],
      widgetList: [],
      panelsDisplay: {},
      selectedPanel: [],
      loaderStatus: false,
      panel_id: 1,
      errorMessage: '',
      confirmMessage: '',
      successMessage: '',
      isDefault: false,
      userPreferences: {},
      imageUrl: '',
      refresh: false
    };
  },
  methods: {
    cancelPreferences() {
      if (this.panel_id === 1 && this.isDefault) {
        this.$emit('closepopup', 'closeBasePopup');
      } else if (this.panel_id === 1 && !this.isDefault) {
        this.confirmMessage = 'Are you sure you want to discard the changes?';
        $('#ConfirmMsgModal').modal('show');
      } else if (!this.isDefault && this.userPreferences) {
        const valueArr = this.selectedPanel.map((item) => item.panel_widget_id);
        const ordered = sortBy(this.userPreferences.card_widgets, 'panel_card_id');
        const savedList = ordered.map((item) => item.panel_widget_id);
        const noChange = savedList.filter((item, idx) => valueArr.indexOf(item) !== idx);
        if (noChange && noChange.length === 0) {
          this.$emit('closepopup', 'closeBasePopup');
        } else {
          this.confirmMessage = 'Are you sure you want to discard the changes?';
          $('#ConfirmMsgModal').modal('show');
        }
      } else {
        this.confirmMessage = 'Are you sure you want to discard the changes?';
        $('#ConfirmMsgModal').modal('show');
      }
    },
    async intialAPIs() {
      this.loaderStatus = true;
      await this.isDefaultDashboard();
      await this.getWidgetListForAccount();
      await this.getUserDashboardPreference();
      this.loaderStatus = false;
    },
    getFormData(filePath) {
      const pathArray = filePath.split('/');
      const fileName = this.filterStringForSpecialCharacters(pathArray.pop());
      const folderName = this.filterStringForSpecialCharacters(pathArray.pop());
      const containerName = this.filterStringForSpecialCharacters(pathArray.pop());
      return {
        container_name: containerName,
        file_name: fileName,
        folder_name: folderName,
        permissions: 'read',
        storage_name: 'rams-storage-java'
      };
    },
    /* filterStringForSpecialCharacters()
     *  replaces the encoded characters from a string
     */
    filterStringForSpecialCharacters(str) {
      return str
        .replace(/%21/g, '!')
        .replace(/%27/g, "'")
        .replace(/%28/g, '(')
        .replace(/%29/g, ')')
        .replace(/%2A/g, '*')
        .replace(/%20/g, ' ');
    },
    async getImageUrl(filePath) {
      if (filePath) {
        const formData = this.getFormData(filePath);
        const token = await getSasToken(formData);
        this.imageUrl = `${process.env.VUE_APP_AZURE_BLOB_URL}/${filePath}${token}`;
      }
    },
    async getPanelInfo() {
      this.panelInfo = await getPanelInfo();
      this.getImageUrl(this.panelInfo[0].image_location);
    },
    async getCardTypeInfo() {
      this.cardTypeInfo = await getCardTypeInfo();
    },
    async getPanelCardWidgetInfo() {
      this.panelCardWidgetInfo = await getPanelCardWidgetInfo();
    },
    async getWidgetListForAccount() {
      this.widgetList = await getWidgetListForAccount(
        JSON.parse(localStorage.getItem('userData')).account_id,
        JSON.parse(localStorage.getItem('userData')).role_id
      );
      if (this.roleId === 7 || this.roleId === 5 || this.roleId === 6) {
        this.widgetList = this.widgetList.filter((item) => item.premium_service_id !== 3);
      }
    },
    async isDefaultDashboard() {
      this.isDefault = await isDefaultDashboard(
        JSON.parse(localStorage.getItem('userData')).account_id,
        JSON.parse(localStorage.getItem('userData')).id
      );
    },
    async getUserDashboardPreference() {
      this.userPreferences = await getUserDashboardPreference(
        JSON.parse(localStorage.getItem('userData')).account_id,
        JSON.parse(localStorage.getItem('userData')).id
      );
      if (!this.isDefault) {
        this.panel_id = this.userPreferences.panel_id;
        this.selectPanel();
      } else {
        this.panel_id = 1;
        this.selectedPanel = [];
      }
    },
    selectPanel() {
      this.refresh = false;
      if (this.panel_id !== 1) {
        this.selectedPanel = [];
        let list;
        this.panelInfo.forEach((panel) => {
          if (panel.id === this.panel_id) {
            this.panelsDisplay = this.panelCardWidgetInfo.find(
              (data) => data.panel_id === this.panel_id
            );
          }
        });
        this.panelsDisplay.card_widget_info.forEach((p, i) => {
          const cardTypeIndex = this.cardTypeInfo.findIndex((card) => card.id === p.card_type_id);
          this.panelsDisplay.card_widget_info[i].cardType = this.cardTypeInfo[cardTypeIndex].name;
          list = [];
          this.widgetList.forEach((widget) => {
            const widgetIndex = widget.card_type_ids.findIndex(
              (cardType) => cardType === p.card_type_id
            );
            if (widgetIndex >= 0) {
              list.push(widget);
            }
          });
          this.panelsDisplay.card_widget_info[i].list = list;
          this.selectedPanel.push({
            panel_card_id: p.id,
            panel_widget_id: null
          });
          this.selectedPanel[0].panel_widget_id = 1;
        });
        if (!this.isDefault && this.panel_id === this.userPreferences.panel_id) {
          this.selectedPanel = [];
          this.selectedPanel = cloneDeep(
            sortBy(this.userPreferences.card_widgets, 'panel_card_id')
          );
        }
      }
    },
    async closePopup(data) {
      if (data) {
        if (this.refresh) {
          // this.loaderStatus = true;
          EventBus.$emit('initializePage', this.refresh);
          // await this.isDefaultDashboard();
          // await this.getWidgetListForAccount();
          // await this.getUserDashboardPreference();
          // this.loaderStatus = false;
        }
        if (this.$route.name !== 'Dashboard') {
          this.$router.push({
            name: 'Dashboard'
          });
        }
        EventBus.$emit('activeMenuTitle', this.$route.meta.title);
        this.$emit('closepopup', 'closeBasePopup');
        $('#basePopup').modal('hide');
      }
    },
    async savePreferences() {
      if (this.panel_id !== 1) {
        const valueArr = this.selectedPanel.map((item) => item.panel_widget_id);
        const isDuplicate = valueArr.some((item, idx) => valueArr.indexOf(item) !== idx);
        let noChange = null;
        if (this.selectedPanel.find((p) => p.panel_widget_id === null)) {
          this.errorMessage = 'Please select all dropdown values';
          $('#ErrorMsgModal').modal('show');
        } else if (isDuplicate) {
          this.errorMessage = 'Please select unique widgets';
          $('#ErrorMsgModal').modal('show');
        } else {
          this.loaderStatus = true;
          let response = {};
          if (this.isDefault && this.userPreferences === null) {
            const formData = {
              account_id: JSON.parse(localStorage.getItem('userData')).account_id,
              user_id: JSON.parse(localStorage.getItem('userId')),
              panel_id: this.panel_id,
              card_widgets: this.selectedPanel
            };
            response = await postUserPreferences(formData);
          } else if (
            !this.isDefault ||
            (this.isDefault &&
              this.userPreferences &&
              this.userPreferences.card_widgets.length === 0)
          ) {
            const ordered = sortBy(this.userPreferences.card_widgets, 'panel_card_id');
            const savedList = ordered.map((item) => item.panel_widget_id);
            noChange = savedList.filter((item, idx) => valueArr.indexOf(item) !== idx);
            if (!this.isDefault && noChange && noChange.length === 0) {
              this.errorMessage = 'No changes done. Please select other widgets';
              $('#ErrorMsgModal').modal('show');
            } else {
              this.loaderStatus = true;
              const formData = {
                account_user_preference_id: this.userPreferences.account_user_preference_id,
                panel_id: this.panel_id,
                card_widgets: this.selectedPanel
              };
              response = await putUserPreferences(formData);
            }
          }
          this.loaderStatus = false;
          if (response.message === 'success' && response.status_code === 200) {
            this.refresh = true;
            this.successMessage = 'Your dashboard preferences have been saved successfully';
            $('#successMsgModal').modal({
              backdrop: 'static',
              keyboard: false
            });
          }
        }
      } else if (this.panel_id === 1 && this.isDefault) {
        this.errorMessage = 'No changes done. Please customize your dashboard';
        $('#ErrorMsgModal').modal('show');
      } else if (this.panel_id === 1 && !this.isDefault) {
        this.refresh = true;
        this.loaderStatus = true;
        const defaultData = {
          account_id: JSON.parse(localStorage.getItem('userData')).account_id,
          user_id: JSON.parse(localStorage.getItem('userId')),
          dashboard_notification_type_id: 4
        };
        const response = await setDefaultPreference(defaultData);
        this.loaderStatus = false;
        if (response.message === 'success' && response.status_code === 200) {
          this.successMessage = 'Your dashboard preferences have been saved successfully';
          $('#successMsgModal').modal({
            backdrop: 'static',
            keyboard: false
          });
        }
      }
    }
  },
  mounted() {},
  async created() {
    this.refresh = false;
    this.loaderStatus = true;
    await this.getPanelInfo();
    await this.getCardTypeInfo();
    await this.getPanelCardWidgetInfo();
    await this.intialAPIs();
    this.loaderStatus = false;
    EventBus.$on('loadDashhboard', () => {
      this.intialAPIs();
    });
  }
};
</script>

<style lang="scss" scoped>
.width-auto {
  width: auto;
}
.default-img {
  width: 80%;
}

.mr-tp-4 {
  margin-top: 4px;
}
.custom-row {
  margin-left: 15px !important;
  margin-right: 15px !important;
}
.custom-font {
  font-family: Roboto;
  font-style: normal;
  @include fontItems($font-14, 19px, $font-weight-medium);
  color: $primary;
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.mr-bt-4 {
  margin-bottom: 4px;
}
.panel-box {
  margin-top: 20px;
  background: $deep-black-alpha;
}
table,
tr,
td {
  border: 2px solid $white;
}
.fw-300 {
  font-weight: 400;
}
.td-child {
  width: 104px;
  height: 76px;
  text-align: center;
  background: $messenger-blue;
  opacity: 0.35;
}
.td-main {
  width: 214px;
  height: 132px;
  text-align: center;
  background: $light-black-alpha;
  opacity: 0.8;
}
.panel-1 {
  height: 150px;
  text-align: center;
  background: $light-black-alpha;
  opacity: 0.8;
  border: 1px solid $deep-white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.panel-other {
  height: 75px;
  text-align: center;
  background: $messenger-blue;
  opacity: 0.35;
  border: 1px solid $deep-white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box1 {
  margin-top: 25px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
}
.multiselect-single-dropdown {
  ::v-deep .multiselect__content-wrapper {
    max-height: 150px !important;
  }
}
@media only screen and (max-width: 600px) {
  .box-wrapper {
    height: 45vh;
    overflow-y: auto;
  }
  .td-main {
    height: 80px;
  }
  .td-child {
    height: 40px;
  }
  .box1 {
    margin-bottom: 25px;
    min-height: 0px;
  }
}
@media only screen and (min-width: 600px) {
  .box-wrapper {
    height: 40vh;
    overflow-y: auto;
  }
  .td-main {
    height: 100px;
  }
  .box1 {
    margin-bottom: 25px;
    min-height: 0px;
  }
}
@media only screen and (min-width: 768px) {
  .box-wrapper {
    height: 50vh;
    overflow-y: auto;
  }
  .ipad-row {
    font-size: 15px;
    width: 110%;
  }
  .td-main {
    height: 70px;
  }
  .box1 {
    margin-bottom: 25px;
    min-height: 0px;
  }
}
@media (min-width: 1025px) and (max-width: 1300px) {
  .box-wrapper {
    height: 45vh;
    overflow-y: auto;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1024px) {
  .box-wrapper {
    height: 53vh;
    overflow-y: auto;
  }
  .td-main {
    height: 150px;
  }
  .box1 {
    margin-bottom: 25px;
    min-height: 0px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .box-wrapper {
    height: 35vh;
    overflow-y: auto;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .box-wrapper {
    height: 40vh;
    overflow-y: auto;
  }
}
@media screen and (width: 812px) {
  .box-wrapper {
    height: 20vh;
    overflow-y: auto;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  .box-wrapper {
    height: 37vh;
  }
  hr {
    margin: 0px;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px) {
  .box-wrapper {
    height: 22vh;
  }
  hr {
    margin: 0px;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px),
  (device-width: 667px) and (device-height: 375px) {
  .box-wrapper {
    height: 24vh;
  }
}
</style>
